// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2kNMw","errorLogs":"EditorFooter_errorLogs__33PFf"};